import { MasterTranslation, TRACKING_PARAM_PARCEL_ID } from '@/constants';
import { useGlobalState } from '@/hooks';
import {
  ButtonColorKey,
  ButtonSize,
  ButtonVariant,
  type ISectionWrapper,
  IconAlignment,
  SectionWrapperVariant,
} from '@/interfaces';
import { gtmTrackingWidget } from '@/utils';
import { useRouter } from 'next/router';
import { type FC, type FormEventHandler, useRef } from 'react';
import LocalShipping from '../../public/images/icons/local_shipping.svg';
import {
  DesktopSectionTitleSmall,
  FormButton,
  FormWrapper,
  Input,
  WidgetSectionWrapper,
} from './TrackingWidget.styles';

const TrackingWidget: FC<ISectionWrapper> = (props) => {
  const router = useRouter();
  const inputRef = useRef<HTMLInputElement>(null);
  const { variant, carrierSlug } = props;
  const { t } = useGlobalState();

  const widgetTitle = t(MasterTranslation.TrackingWidgetLabel);
  const widgetPlaceholder = t(MasterTranslation.TrackingWidgetPlaceholderSeoPages);
  const trackParcelButtonText = t(MasterTranslation.TrackingWidgetCtaDesktop);
  const trackButtonText = t(MasterTranslation.TrackingWidgetCtaMobile);

  const handleSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    const trackingId = inputRef.current?.value;
    if (!trackingId) return;
    gtmTrackingWidget();
    // PMC -> PMT, must call sever-side requests in PMT
    const params = new URLSearchParams({ [TRACKING_PARAM_PARCEL_ID]: trackingId });
    if (carrierSlug) params.set('carrier_slug', carrierSlug);
    void router.push(`/track-my-parcel?${params.toString()}`);
  };

  return (
    <WidgetSectionWrapper variant={variant}>
      <DesktopSectionTitleSmall>{widgetTitle}</DesktopSectionTitleSmall>
      <FormWrapper onSubmit={handleSubmit}>
        <Input
          aria-label='Tracking ID'
          ref={inputRef}
          name={TRACKING_PARAM_PARCEL_ID}
          autoComplete='off'
          placeholder={widgetPlaceholder}
          data-lpignore='true' //remove extension icon
        />
        <FormButton
          type='submit'
          variant={ButtonVariant.Primary}
          color={ButtonColorKey.Yellow}
          icon={LocalShipping}
          size={ButtonSize.Medium}
          mobileSize={ButtonSize.Large}
          alignment={IconAlignment.Left}
        >
          {variant === SectionWrapperVariant.RowDisplay ? trackParcelButtonText : trackButtonText}
        </FormButton>
      </FormWrapper>
    </WidgetSectionWrapper>
  );
};

export default TrackingWidget;
